// Comisión que cobra el banco (Ficohsa) por cobros con POS o Link de pago.
// El banco debita ese % de la MISMA cuenta de débito donde entró el cobro.
// En la app se registra como un gasto "Comisiones bancarias" para que Merly
// no lo tenga que ingresar a mano y se refleje en el Balance y la utilidad.
//
// Nota: el % está fijo aquí (un solo lugar). Si algún día se vuelve
// configurable por negocio, este valor pasa a ser solo el valor por defecto.
export const COMISION_POS_PCT = 4; // %

// Categoría de gasto donde cae la comisión (ya viene en la lista del negocio).
export const CATEGORIA_COMISION = 'Comisiones bancarias';

const round2 = (n) => Math.round(n * 100) / 100;

// Monto de comisión sobre lo cobrado. 0 si no aplica o si la base es 0.
export function calcularComision(base, pct = COMISION_POS_PCT) {
  const b = Math.max(Number(base) || 0, 0);
  const p = Math.max(Number(pct) || 0, 0);
  return round2((b * p) / 100);
}
